import { createMutation, createSuspenseQuery } from "@steto-care/steto-query";

import { BillingRepository } from "@/io/repository/BillingRepository.ts";
import { PractitionerBillingStatus } from "@/models/PractitionerBillingModel.ts";

export class BillingQueries {
  constructor(private readonly billing: BillingRepository = new BillingRepository()) {}

  /*******************************/
  /*********** QUERIES ***********/
  /*******************************/

  usePractitionerBillingFiles = createSuspenseQuery(
    "practitioner-billing-files",
    () => [],
    async () => this.billing.getBillingFiles(),
  );

  /*******************************/
  /********** MUTATIONS **********/
  /*******************************/

  usePractitionerBillingStatus = createMutation(
    "practitioner-billing-status",
    async (data: { billingId: string; status: PractitionerBillingStatus }) =>
      this.billing.changeBillingFileStatus(data.billingId, data.status),
    {
      onSuccess: (_, __, { client }) => {
        this.usePractitionerBillingFiles.invalidate(client, {});
      },
    },
  );
}
